var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.099,
    height: 16.1,
    viewBox: "0 0 16.099 16.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5920",
    "data-name": "Group 5920",
    transform: "translate(-935.95 -278.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-components-1286164",
    d: "M98,28v7.11h7.111V28Zm8.889,0v7.11H114V28Zm-8.052.836h5.437v5.438H98.837Zm8.888,0h5.438v5.438h-5.438ZM98,36.889V44h7.111V36.888Zm12.444,0A3.556,3.556,0,1,0,114,40.443,3.561,3.561,0,0,0,110.444,36.889Zm-11.607.837h5.437v5.437H98.837Zm11.607,0a2.718,2.718,0,1,1-2.719,2.718,2.712,2.712,0,0,1,2.719-2.718Z",
    transform: "translate(838 251)",
    stroke: "#333",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
export default __webpack_public_path__ + "static/media/component.9b9a567c4f44c7b2138ce39187cb1052.svg";
export { ForwardRef as ReactComponent };